import { WidgetTeaserStandard } from 'components/partials/widget/teaser/standard';
import widgetTeaserData from 'stories/dummy/teaser-data';
import { createImage } from 'tests/utils';
import type { WidgetTeaserItemProps } from 'types/cms-teaser';

export const createTeaser = ({ id }: { id?: string }): WidgetTeaserItemProps => ({
  model: {
    id: id ?? '1001',
    image: createImage({
      baseUrl: `https://dummyimage.com/800x450/000/fff.jpg&text=image-${id}`,
    }),
    fields: {
      title: `Placeholder teaser ${id} headline`,
    },
    url: `https://www.dummyUrl.com/${id}`,
    hasVideo: false,
  },
  type: 'storyline',
});

export const WidgetAutonativeIndex = () => {
  const teaserData = JSON.parse(JSON.stringify(widgetTeaserData));
  teaserData.items?.splice(3);

  return (
    <div className="native-teaser-segment">
      <WidgetTeaserStandard
        isSponsored
        context={{
          model: {
            fields: {
              title: 'Placeholder headline',
              link: {
                url: '#',
                target: '_self',
              },
            },
          },
          items: Array.from(Array(3), (_, index: number) => createTeaser({ id: `${index + 1}` })),
        }}
      />
    </div>
  );
};
